import html2pdf from "html2pdf.js";
import { generateVendorHTML } from "./generateVendorHtml";

export const generateVendorPDF = (response) => {
  const html = generateVendorHTML(response);

  html2pdf()
    .set({
      margin: 10,
      filename: `Vendor_${response.Data.Vendor.VendorName}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "mm", format: "a4" },
    })
    .from(html)
    .outputPdf("bloburl") // ✅ generate PDF as blob URL
    .then((pdfUrl) => {
      window.open(pdfUrl, "_blank"); // ✅ open in new tab
    });
};
